const SCROLL_OFFSET = 0.1;

export default class Slider {

    allCells?: Array<HTMLElement>;
    selectedCells?: Array<HTMLElement>;
    selectedIndices?: Array<number>;
    prevElement?: HTMLElement;
    nextElement?: HTMLElement;

    carouselRef?: any;

    constructor(carouselRef) {

        this.allCells = [];
        this.selectedCells = [];
        this.selectedIndices = [];
        this.prevElement = null;
        this.nextElement = null;

        this.carouselRef = carouselRef;
    }

    init(callback?: Function) {
        this.updateSelectedCells();
        this.updatePrevNextElements();

        if (typeof callback === 'function') {
            callback({
                selectedCells: this.selectedCells,
                selectedIndicies: this.selectedIndices,
                nextElement: this.nextElement,
                prevElement: this.prevElement,
                initialIndex: this.selectedIndices[0],
            });
        }
    }

    getSliderProps() {
        return this;
    }

    updateSelectedCells() {
        const element = this.carouselRef;

        if (element) {
            // Convert HTMLCollections to Array
            this.allCells = Array.from(element.children);

            // Use scroll position instead of getBoundingClientRect for better off-screen support
            const containerScrollLeft = element.scrollLeft;
            const containerWidth = element.clientWidth;

            const selectedCells = Array.from(this.allCells).filter((child: HTMLElement) => {
                const childOffsetLeft = child.offsetLeft;
                const childWidth = child.offsetWidth;
                
                // Check if element is within the scrollable view with small offset
                const scrollOffset = childWidth * SCROLL_OFFSET;
                return childOffsetLeft + scrollOffset < containerScrollLeft + containerWidth && 
                       childOffsetLeft + childWidth - scrollOffset > containerScrollLeft;
            });

            if (selectedCells.length > 0) {
                this.selectedCells = selectedCells;
                this.selectedIndices = selectedCells.map((cell) => this.allCells.indexOf(cell));
            } else {
                // do we need to reset?
                this.selectedCells = [];
                this.selectedIndices = [];
            }
        }
    }

    scrollToElement(element, direction) {

        const slider = this.carouselRef;

        if (slider && element) {
            const elementRect = element.getBoundingClientRect();

            let newScrollPosition;
            if (direction === 'left') {
                newScrollPosition = element.offsetLeft - (elementRect.width * (this.selectedCells.length - 1));
            }
            else {
                newScrollPosition = element.offsetLeft;
            }

            slider.scroll({
                left: newScrollPosition,
                behavior: 'smooth',
            });
        }
    }

    scrollRight() {
        this.scrollToElement(this.nextElement, 'right');
    };

    scrollLeft() {
        this.scrollToElement(this.prevElement, 'left');
    };

    updatePrevNextElements() {
        const firstVisibleIndex = this.selectedIndices[0];
        const lastVisibleIndex = this.selectedIndices[this.selectedIndices.length - 1];

        this.prevElement = firstVisibleIndex > 0 ? this.allCells[firstVisibleIndex - 1] : null;
        this.nextElement = lastVisibleIndex < this.allCells.length - 1 ? this.allCells[lastVisibleIndex + 1] : null;
    };

    updateAfterScroll(callback?: Function) {

        const firstVisibleIndex = this.selectedIndices[0];

        this.init();

        const currentVisibleIndex = this.selectedIndices[0];

        const direction = firstVisibleIndex > currentVisibleIndex ? 'left' : 'right';

        const width = this.carouselRef?.clientWidth;

        if (typeof callback === 'function') {
            callback({
                direction,
                width,
                selectedCells: this.selectedCells,
                selectedIndicies: this.selectedIndices,
                nextElement: this.nextElement,
                prevElement: this.prevElement,
            });
        }
    }
}
